



















































































































































































































































































































































































































































































































import Vue from 'vue';
import { defs, isString, isObject, isArray, DefinitionsImportOptions } from 'expangine-runtime';
import { getConfirmation } from './app/Confirm';
import { sendNotification } from './app/Notify';
import { getRunProgram } from './app/RunProgram';
import { getDebugProgram } from './app/DebugProgram';
import { DefinitionsSaver, DefinitionsPatch } from './app/DefinitionsSaver';
import { getSimpleInput } from './app/SimpleInput';
import { getFile, FileImportStatus } from './app/FileImport';
import { getProjectImport } from './app/ProjectImport';
import { getProjectExport } from './app/ProjectExport';
import { System } from './app/SystemEvents';
import { Preferences, PreferenceCategory } from './app/Preference';
import { ShortcutContext, Shortcuts } from './app/Shortcuts';
import { ExplorerTab } from './app/explorer/ExplorerTypes';
import { addEntity } from './app/EntityBuilders';
import { getInput } from './app/Input';
import { clearEntity } from './app/EntityBuilders';
import Registry from './runtime';



const PREF_DISABLE_AUTO_SAVE = Preferences.define({
  key: 'disable_auto_save',
  label: 'Disable auto save without confirmation',
  category: [PreferenceCategory.EDITOR, PreferenceCategory.CONFIRM],
  defaultValue: false,
});

const PREF_EXAMPLE_OVERWRITE = Preferences.define({
  key: 'example_overwrite',
  label: 'Overwrite project with examples without confirmation',
  category: [PreferenceCategory.EDITOR, PreferenceCategory.CONFIRM],
  defaultValue: false,
});

const PREF_CLEAR_HISTORY = Preferences.define({
  key: 'clear_history',
  label: 'Clear undo/redo history without confirmation',
  category: [PreferenceCategory.EDITOR, PreferenceCategory.CONFIRM],
  defaultValue: false,
});

const PREF_AUTO_SAVE = Preferences.define({
  key: 'auto_save',
  label: 'Auto-save project',
  category: [PreferenceCategory.EDITOR],
  defaultValue: true,
});

const PREF_SHORTCUT_SAVE = Preferences.define({
  key: 'shortcut_save',
  label: 'Save shortcut',
  category: [PreferenceCategory.EDITOR, PreferenceCategory.SHORTCUT],
  defaultValue: '83__c',
  component: 'ex-shortcut-input',
});

const PREF_SHORTCUT_OPEN = Preferences.define({
  key: 'shortcut_open',
  label: 'Open shortcut',
  category: [PreferenceCategory.EDITOR, PreferenceCategory.SHORTCUT],
  defaultValue: '79__c',
  component: 'ex-shortcut-input',
});

const PREF_SHORTCUT_UNDO = Preferences.define({
  key: 'shortcut_undo',
  label: 'Undo shortcut',
  category: [PreferenceCategory.EDITOR, PreferenceCategory.SHORTCUT],
  defaultValue: '90__c',
  component: 'ex-shortcut-input',
});

const PREF_SHORTCUT_REDO = Preferences.define({
  key: 'shortcut_redo',
  label: 'Redo shortcut',
  category: [PreferenceCategory.EDITOR, PreferenceCategory.SHORTCUT],
  defaultValue: '90_sc',
  component: 'ex-shortcut-input',
});

const PREF_SHORTCUT_NEW = Preferences.define({
  key: 'shortcut_new',
  label: 'New Project shortcut',
  category: [PreferenceCategory.EDITOR, PreferenceCategory.SHORTCUT],
  defaultValue: '78__c',
  component: 'ex-shortcut-input',
});

const PREF_SHORTCUT_OPERATIONS = Preferences.define({
  key: 'shortcut_operations',
  label: 'Operation Explorer shortcut',
  category: [PreferenceCategory.EDITOR, PreferenceCategory.SHORTCUT],
  defaultValue: '79_sc',
  component: 'ex-shortcut-input',
});

const PREF_SHORTCUT_EXPLORER_SEARCH = Preferences.define({
  key: 'shortcut_explorer_search',
  label: 'Focus on explorer search',
  category: [PreferenceCategory.EDITOR, PreferenceCategory.SHORTCUT],
  defaultValue: '70_sc',
  component: 'ex-shortcut-input',
});

const PREF_SHOW_EXAMPLES = Preferences.define({
  key: 'first',
  label: 'Show examples dialogue on startup',
  category: [PreferenceCategory.EDITOR],
  defaultValue: true,
});


const saver = new DefinitionsSaver(Registry.defs);

export default Vue.extend({
  name: 'Editor',
  data: () => ({
    registry: Registry,
    // Editor Properties
    initialized: false,
    autoSave: Preferences.get(PREF_AUTO_SAVE),
    mode: 0,
    examples: [] as any[],
    showExamples: false,
    dataDebounce: 60 * 1000,
    dataTimeout: -1,
    loading: 0,
    showOperations: false,
    preferences: false,
    // History
    undos: saver.undos,
    redos: saver.redos,
    historyDrawer: false,
    // Preferences
    prefs: Preferences.values,
    // Explorer
    explorerSearch: '',
    explorerSearchFocuses: 0,
    currentTab: -1,
    tabs: [] as ExplorerTab[],
    explorerVisible: true,
  }),
  computed: 
  {
    historyEmpty(): boolean {
      return this.undos.length === 0 && this.redos.length === 0;
    },
    undosReversed(): DefinitionsPatch[] {
      return this.undos.slice().reverse();
    },
    shortcuts(): ShortcutContext {
      return {
        id: 'app',
        downs: {
          [Preferences.get(PREF_SHORTCUT_SAVE)]: this.exportJson,
          [Preferences.get(PREF_SHORTCUT_OPEN)]: this.importJson,
          [Preferences.get(PREF_SHORTCUT_NEW)]: this.reset,
          [Preferences.get(PREF_SHORTCUT_UNDO)]: this.historyUndo,
          [Preferences.get(PREF_SHORTCUT_REDO)]: this.historyRedo,
          [Preferences.get(PREF_SHORTCUT_OPERATIONS)]: () => this.showOperations = true,
          [Preferences.get(PREF_SHORTCUT_EXPLORER_SEARCH)]: () => this.explorerSearchFocuses++,
        },
        ups: {

        },
      };
    },
    hasExamples(): boolean {
      return this.examples.length > 0;
    },
    isLoading(): boolean {
      return this.loading > 0;
    },
    isDataSaved(): boolean {
      return this.dataTimeout === -1;
    },
    explorerSearchPlaceholder(): string {
      const shortcut = Shortcuts.nameFromCode(Preferences.get(PREF_SHORTCUT_EXPLORER_SEARCH));

      return `Search (${shortcut})`;
    },
  },
  async mounted() 
  {
    System.off('loading').on('loading', this.handleLoading);
    System.off('openTab').on('openTab', (type, tab) => this.openTab(tab));
    System.off('closeTab').on('closeTab', (type, tab) => this.closeTab(tab));

    let loaded = false;
    const shareName = window.location.href.match(/share=([^&]*)/);
    if (shareName && shareName[1]) {
      window.history.replaceState({}, document.title, window.location.href.split('?')[0]);

      try {
        const shareResponse = await fetch('shares/' + shareName[1]);

        if (shareResponse.ok) {
          const shareData = await shareResponse.json();

          await saver.clear();

          this.registry.defs.sync(shareData as DefinitionsImportOptions);
          loaded = true;
        }
      } catch (e) {
        window.console.log('share load error', e);
      }
    }
    if (!loaded) {
      await saver.load();
    }
    
    this.loadExamples();
    
    this.registry.defs.entities.forEach((_, entityName) => addEntity(this.registry, entityName));

    this.initialized = true;
  },
  methods: 
  {
    openTab(tab: ExplorerTab) 
    {
      const i = this.tabs.findIndex((t) => t.id === tab.id);
      if (i === -1) {
        this.currentTab = this.tabs.length;
        this.tabs.push(tab);
      } else {
        this.currentTab = i;
      }
    },
    closeTab(tab: ExplorerTab) 
    {
      const i = this.tabs.findIndex((t) => t.id === tab.id);
      if (i !== -1) {
        this.tabs.splice(i, 1);
        if (this.currentTab >= this.tabs.length) {
          this.currentTab = this.tabs.length - 1;
        }
      }
    },
    async historyUndo() 
    {
      this.loadable(() => saver.undo());
    },
    async gotoUndo(index: number) 
    {
      this.loadable(() => saver.undoMany(index + 1));
    },
    async historyRedo() 
    {
      this.loadable(() => saver.redo());
    },
    async gotoRedo(index: number) 
    {
      this.loadable(() => saver.redoMany(this.redos.length - index));
    },
    async historyClear() 
    {
      if (await getConfirmation({ pref: PREF_CLEAR_HISTORY })) 
      {
        this.loadable(() => saver.clear());
      }
    },
    async toggleAutoSave()
    {
      if (this.autoSave) {
        await getConfirmation({
          title: 'Disable Auto Save',
          message: 'Your work will no longer be saved to your browser. Would you like to <b>clear</b> the data from your browser or <b>leave</b> it there for next time you visit?',
          confirm: 'Clear',
          unconfirm: 'Leave',
          pref: PREF_DISABLE_AUTO_SAVE,
        });
      }

      this.autoSave = !this.autoSave;

      Preferences.set(PREF_AUTO_SAVE, this.autoSave);
    },
    toggleExplorerVisible()
    {
      this.explorerVisible = !this.explorerVisible;
    },
    async handleLoading(eventType: 'loading', loadable: () => Promise<any>)
    {
      this.loadable(loadable);
    },
    async loadable<R = any>(callback: () => R | Promise<R>): Promise<R | undefined>
    {
      let result: R | undefined;
      this.loading++;

      try
      {
        await this.$nextTick();

        result = await callback();
      }
      catch (e)
      {
        sendNotification({ message : 'There was an unexpected error: ' + e });

        window.console.log('error in loadable', e);
      }

      this.loading--;

      return result;
    },
    async loadExamples() 
    {
      this.loadable(async () => 
      {
        const response = await fetch('examples/index.json');
        const examples = await response.json();

        if (isArray(examples)) 
        {
          this.examples = examples;

          if (!saver.loaded && examples.length > 0 && Preferences.get(PREF_SHOW_EXAMPLES)) {
            this.showExamples = true;
            
            Preferences.set(PREF_SHOW_EXAMPLES, false);
          }
        }
      });
    },
    async loadExample(url: string) 
    {
      this.loadable(async () => 
      {
        const response = await fetch(url);
        const data = await response.json();

        if (isObject(data) && data.type && data.settings && data.program) 
        {
          if (this.showExamples || await getConfirmation({ message: 'This will overwrite your current program, are you sure?', pref: PREF_EXAMPLE_OVERWRITE })) 
          {
            await this.importData(data);
          } 
          else 
          {
            sendNotification({ message: 'Importing example canceled.' });
          }
        } 
        else 
        {
          sendNotification({ message: 'This example seems corrupted, sorry!' });
        }

        this.showExamples = false;
      });
    },
    async share()
    {
      const name = await getInput({ title: 'Share Name', matches: /^[\w-]+$/i });

      if (!name) {
        return;
      }

      const secret = await getInput({ title: 'Share Password', message: 'If you are not sure what the password is, ask The Creator.' });

      if (!secret) {
        return;
      }

      const data = JSON.stringify(this.registry.defs.export());

      const formData = new FormData();
      formData.append('name', name);
      formData.append('secret', secret);
      formData.append('data', data);

      const response = await fetch('api/share.php', {
        method: 'post',
        body: formData,
      });

      const result = await response.json();

      if (result) {
        await getInput({ message: 'Project shared!', value: window.location + 'shared/' + name + '?program=' + this.registry.defs.programs.keys[0] });
      } else {
        await sendNotification({ message: 'Sorry, either the password was incorrect or the name is already taken.' });
      }
    },
    async reset() 
    {
      const resetting = await getSimpleInput({
        title: 'New Project',
        value: {
          programs: true,
          functions: true,
          data: true,
          types: true,
        },
        fields: [
          { name: 'programs', type: 'boolean', label: 'Programs?' },
          { name: 'functions', type: 'boolean', label: 'Functions?' },
          { name: 'data', type: 'boolean', label: 'Data?' },
          { name: 'types', type: 'boolean', label: 'Types & Relations?' },
        ],
      });

      if (!resetting)
      {
        return await sendNotification({ message: 'Reset canceled.' });
      }

      
      if (resetting.programs)
      {
        this.registry.defs.clearPrograms();
      }

      if (resetting.data)
      {
        this.registry.defs.clearData();
      }

      if (resetting.functions)
      {
        this.registry.defs.clearFunctions();
      }

      if (resetting.types)
      {
        this.registry.defs.clearEntities();
        this.registry.defs.clearRelations();

        clearEntity(this.registry);
      }
    },
    async exportJson() 
    {
      const exportResult = await getProjectExport({
        defs: this.registry.defs,
      });

      if (isString(exportResult)) 
      {
        sendNotification({ message: exportResult });
      } 
      else 
      {
        sendNotification({ message: 'Project exported.' });
      }
    },
    async importJson() 
    {
      this.loadable(async () => 
      {
        const result = await getFile({ accept: '.json', json: true });

        switch (result.status) {
          case FileImportStatus.SUCCESS:
            await this.importData(result.json, true);
            break;
          case FileImportStatus.NONE_SELECTED:
            sendNotification({ message: 'No file selected.' });
            break;
          case FileImportStatus.NOT_TEXT_FILE:
            sendNotification({ message: 'The file selected was not a valid file.' });
            break;
          case FileImportStatus.ERROR_PARSING_JSON:
            sendNotification({ message: 'The file selected did not contain a valid JSON value.' });
            break;
        }
      });
    },
    async importData(imported: any, customize: boolean = false) 
    {  
      const { registry } = this;

      const importResult = await getProjectImport({
        imported,
        customize,
        registry,
      });

      if (isString(importResult)) 
      {
        sendNotification({ message: importResult });
      }
    },
    async runProgram() 
    {
      const registry = this.registry;
      const program = defs.programs.values[0];

      try
      {
        await getRunProgram({ registry, program });
      } 
      catch (e) 
      {
        sendNotification({ message: 'There was an error in your program' });
        
        window.console.log('error in run program', e);
      }
    },
    async debugProgram() 
    { 
      const registry = this.registry;
      const currentProgram = defs.programs.values[0];
      const { expression: program, dataType: type, datasets } = currentProgram;

      try 
      {
        await getDebugProgram({ registry, type, program, data: datasets[0].data });
      } 
      catch (e) 
      {
        sendNotification({ message: 'There was an error in your program' });
        
        window.console.log('error in debug program', e);
      }
    },
  },
});
